import React from 'react'
import { Modal, Button, Grid, Icon, Divider } from 'semantic-ui-react';
import AvatarEditor from 'react-avatar-editor';
import logo from './../../../images/logo/logo-128.png'
import axios from 'axios'
import { dispatch } from '@rematch/core';
let CLOUDENARY_UPLOAD_PRESET;
let CLOUDENARY_URL;

class ImageResizer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            image: props.image,
            allowZoomOut: true,
            position: { x: 0.5, y: 0.5 },
            scale: 1,
            rotate: 0,
            borderRadius: props.borderRadius,
            preview: null,
            width: props.width,
            height: props.height,
            open: true,
            imageError: '',
            playbookImages:[]
        }
    }

    handleScale = e => {

        const scale = parseFloat(e.target.value)
        this.setState({ scale })
        this.setState({ oldScale: e.target.value })
        this.setState({ fitToScreen: false })
    }

    componentDidUpdate(prevProps) {
        if (prevProps.playbookImagesBuffer !== this.props.playbookImagesBuffer) {
            this.convertPlaybookImages();
        }
    }

    convertPlaybookImages = async () => {
        const { playbookImagesBuffer } = this.props;
        const playbookImages = [];
        
        for (const buffer of playbookImagesBuffer) {
            const blob = new Blob([buffer], { type: 'image/jpeg' });
            const url = URL.createObjectURL(blob);
            playbookImages.push(url);
        }

        this.setState({ playbookImages });
    }

    fitScreen = ({ target: { checked: fitToScreen } }) => {
        if (fitToScreen) {
            this.setState({ scale: 1 })
        } else {
            this.setState({ scale: this.state.oldScale ? this.state.oldScale : this.state.scale })
        }
        this.setState({ fitToScreen })
    }

    rotateLeft = e => {
        e.preventDefault()
        let rotateTo = this.state.rotate - 90;
        this.setState({
            rotate: rotateTo,
            width: rotateTo % 180 === 0 ? this.props.width : this.props.height,
            height: rotateTo % 180 === 0 ? this.props.height : this.props.width
        })
    }

    rotateRight = e => {
        e.preventDefault()
        let rotateTo = this.state.rotate + 90;
        this.setState({
            rotate: rotateTo,
            width: rotateTo % 180 === 0 ? this.props.width : this.props.height,
            height: rotateTo % 180 === 0 ? this.props.height : this.props.width
        })
    }

    handleBorderRadius = e => {
        const borderRadius = parseInt(e.target.value)
        this.setState({ borderRadius })
    }

    handleXPosition = e => {
        const x = parseFloat(e.target.value)
        this.setState({ position: { ...this.state.position, x } })
    }

    handleYPosition = e => {
        const y = parseFloat(e.target.value)
        this.setState({ position: { ...this.state.position, y } })
    }

    handleWidth = e => {
        const width = parseInt(e.target.value)
        this.setState({ width })
    }

    handleHeight = e => {
        const height = parseInt(e.target.value)
        this.setState({ height })
    }

    logCallback(e) {
        // eslint-disable-next-line

    }

    setEditorRef = editor => {
        if (editor) this.editor = editor
    }

    handlePositionChange = position => {
        this.setState({ position })
    }

    changeImage(event) {
        if (event.target.files[0]) {
            var file = event.target.files[0];
            let type = file.name.split('.').pop();
            if (type === 'jpeg' || type === 'JPEG' || type === 'jpg' || type === 'JPG' || type === 'png' || type === 'PNG' || type === 'gif' || type === 'GIF' || type === 'svg' || type === 'SVG') {
                this.setState({ image: file, imageError: '' })
            }
            else {
                this.setState({ imageError: 'Only .jpeg, .jpg, .png, .gif, .tif formats are allowed.' })
            }
        }
    }
    handleTileClick = (imageUrl) => {
        this.setState({ image: imageUrl });
    }

    handleSave = async data => {


        CLOUDENARY_URL = this.props.envData.cloudenaryUrl;
        CLOUDENARY_UPLOAD_PRESET = this.props.envData.preset;
        const img = this.editor.getImageScaledToCanvas().toDataURL()
        const rect = this.editor.getCroppingRect()

        this.setState({
            preview: {
                img,
                rect,
                scale: this.state.scale,
                width: this.state.width,
                height: this.state.height,
                borderRadius: this.state.borderRadius,
            },
        })
        this.props.openImageModal(false);
        this.props.cloudinaryImage(null)
        var formData = new FormData();
        formData.append('file', img);
        formData.append('upload_preset', CLOUDENARY_UPLOAD_PRESET)

        await axios({
            url: CLOUDENARY_URL,
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            data: formData
        }).then((res) => {
            this.props.cloudinaryImage(res)
            this.setState({ imageError: '' })
        }).catch((err) => {
            this.setState({ imageError: '' })
            throw err;
        });
    }



    handleClose = () => {
        dispatch.lifeCycle.setPlaybookImagesBuffer([])
        this.setState({ image: this.props.image, imageError: '' })
        this.props.openImageModal(false);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.image !== nextProps.image) {
            this.setState({ image: nextProps.image })
        }
    }

    render() {

        const { playbookImages } = this.state;
        let widthSetting = this.state.width < 250
        return (
            <Modal
                open={this.props.open}
                onClose={this.handleClose}
                className="basicModal"
                closeOnEscape={true}
                closeOnDimmerClick={false}
                closeIcon
                style={widthSetting ? { width: "600px"  } : { width: "800px"}}

            >
                <Modal.Header>Update Image</Modal.Header>
                <Divider />
                <Modal.Content className="modal-content-scrollable">
                    <Modal.Description>
                        <Grid >
                            <Grid.Row>
                                <Grid.Column width={widthSetting ? 10 : 12} >
                                    <div className="float-left display-block" width={this.props.width} height={this.props.height}>
                                        <AvatarEditor
                                            ref={this.setEditorRef}
                                            image={this.state.image ? this.state.image : logo}
                                            scale={parseFloat(this.state.scale)}
                                            width={this.state.width}
                                            height={this.state.height}
                                            position={this.state.position}
                                            onPositionChange={this.handlePositionChange}
                                            rotate={parseFloat(this.state.rotate)}
                                            borderRadius={this.props.borderRadius ? this.state.width / (100 / this.state.borderRadius) : 0}
                                            onLoadFailure={this.logCallback.bind(this, 'onLoadFailed')}
                                            onLoadSuccess={this.logCallback.bind(this, 'onLoadSuccess')}
                                            onImageReady={this.logCallback.bind(this, 'onImageReady')}
                                            crossOrigin="anonymous"
                                        />
                                        <label htmlFor="file-uploada" className=" image_resize-icon">
                                            {/* <Icon name='pencil' className="w_24" type="file" /> */}
                                            <Icon type="file" className="circular_24_icon first-rectangle-image" name='pencil' />
                                        </label>
                                        <input id="file-uploada" onChange={(e) => this.changeImage(e)} type="file" accept="image/x-png,image/gif,image/jpeg" />

                                    </div>
                                </Grid.Column>

                                <Grid.Column width={widthSetting ? 6 : 4}>

                                    <label>Zoom</label>
                                    <p>
                                        <input
                                            name="scale"
                                            type="range"
                                            onChange={this.handleScale}
                                            min={this.state.allowZoomOut ? '0.1' : '1'}
                                            max="2"
                                            step="0.01"
                                            defaultValue="1"
                                        />
                                    </p>
                                    <label>Rotate</label>
                                    <p>
                                        <Button className="button-cancel" onClick={this.rotateLeft}>
                                            <Icon size="big" name="undo" style={{ margin: 0 }} />
                                        </Button >
                                        <Button className="button-cancel" onClick={this.rotateRight}>
                                            <Icon size="big" name="redo" style={{ margin: 0 }} />
                                        </Button >
                                    </p>
                                    {/* <p>
                                        <input
                                            name="allowZoomOut"
                                            type="checkbox"
                                            onChange={this.handleAllowZoomOut}
                                            checked={this.state.allowZoomOut}
                                        /> &nbsp;&nbsp;
                                        <label>Fit to Screen</label>
                                    </p> */}
                                    <p>
                                        <input
                                            name="fitScreen"
                                            type="checkbox"
                                            onChange={this.fitScreen}
                                            checked={this.state.fitToScreen}
                                        /> &nbsp;&nbsp;
                                        <label>Fit to Screen</label>
                                    </p>

                                </Grid.Column>

                            </Grid.Row>
                            {this.state.imageError && (
                                <Grid.Row>
                                    <Grid.Column width={16}>
                                        <span className="clr-red">{this.state.imageError}</span>
                                    </Grid.Column>
                                </Grid.Row>
                            )}
                            <Grid.Row>
                                <Grid.Column width={16}>
                                    {this.state.playbookImages.length > 0 && (
                                        <div className="image-tiles">
                                            {this.state.playbookImages.map((imageUrl, index) => (
                                                <img
                                                    key={index}
                                                    src={imageUrl}
                                                    alt={`suggestion-${index}`}
                                                    onClick={() => this.handleTileClick(imageUrl)}
                                                    style={{
                                                        cursor: 'pointer',
                                                        width: '50px',
                                                        height: '50px',
                                                        margin: '5px'
                                                    }}
                                                />
                                            ))}
                                        </div>
                                    )}
                                    {this.props.loadingImages && <div><Icon name='circle notched' size='large' loading/><span>loading suggestions</span></div>}
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Modal.Description>
                </Modal.Content>
                <Modal.Actions>
                    <Button className="button-submit float-right" onClick={() => this.handleSave()} >Update</Button>
                    <Button className="button-cancel " onClick={this.handleClose} >Cancel</Button>
                </Modal.Actions>
            </Modal>
        )
    }
}

export default ImageResizer;


